/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';

const KanbanView = () => import('./KanbanView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      component: KanbanView,
      roles: ['administrator', 'agent'],
    },
    {
      path: frontendURL('accounts/:accountId/kanban/funnels'),
      name: 'kanban_funnels',
      component: KanbanView,
      roles: ['administrator', 'agent'],
    },
  ],
};
